import { useNavigate } from "react-router-dom";
import { ReactComponent as AcedImg } from "../../../assets/images/AcedWhite.svg";
import { ReactComponent as Trophy } from "../../../assets/images/Trophy.svg";
import Button from "../../../components/essentials/button/Button";
import "./Success.scss";

const Success: React.FC<{ isProfile: boolean }> = ({ isProfile }) => {
  const navigate = useNavigate();
  const profileOrSignUp = () =>
    isProfile ? (
      <>
        <div className="success__captions">
          <Trophy />
          <p className="success__captions-title">Profile Completed!</p>
        </div>

        <Button className="btn btn-primary ">Confirm</Button>
      </>
    ) : (
      <>
        <div className="success__captions">
          <Trophy />
          <p className="success__captions-title">Success!</p>
          <p className="success__captions-subtitle">
            Hi, Name
            {/* {name} */}
          </p>
        </div>

        <Button className="btn btn-primary " action={() => navigate("/login")}>
          Login
        </Button>
      </>
    );

  return (
    <>
      <div className="success">
        <AcedImg />
        {profileOrSignUp()}
      </div>
    </>
  );
};

export default Success;
